import React, { FC } from 'react';

import { formatPrice } from 'utils';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { useGolfShopStore } from 'stores/hooks';
import { ProductType } from 'api';

const Wrapper = styled.div`
  cursor: pointer;
  margin-top: 32px;

  &:hover {
    transform: scale(1.005);
  }

  img {
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    width: 100%;
    object-fit: contain;
    height: 212px;
    background: white;
    @media (max-width: 768px) {
      height: auto;
    }
  }

  .product-info {
    margin-top: 8px;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    display: flex;
    background: white;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 0 16px;
    gap: 8px;
  }

  .product-name {
    font-size: 15px;
    display: flex;
    flex-wrap: wrap;
  }

  .price-wrapper {
    display: flex;
    align-items: center;

    & .from-price {
      padding-right: 5px;
      font-weight: normal;
      font-size: 15px;
    }
  }

  .product-price {
    font-weight: bold;
    font-size: 20px;
  }
`;

interface IProps {
  productName: string;
  productImgSrc: string;
  productPrice: number;
  productType: ProductType;
  onClickCallback: () => void;
}

export const Product: FC<IProps> = observer(({ productName, productImgSrc, productPrice, productType, onClickCallback }) => {
  const { currencySymbol, currency, isMultiProduct } = useGolfShopStore();

  const isMultiProductType = isMultiProduct(productType);

  return (
    <Wrapper onClick={onClickCallback}>
      <img src={productImgSrc} alt={productName} />
      <div className="product-info">
        <span className="product-name">{productName}</span>
        <div className="price-wrapper">
          {isMultiProductType && <span className="from-price">from</span>}
          <span className="product-price">
            {formatPrice(productPrice, currency)}
            {currencySymbol}
          </span>
          <div className="per-year">&nbsp;/yr</div>
        </div>
      </div>
    </Wrapper>
  );
});
